module.exports = __webpack_public_path__ + "static/media/src_image_icon_labelfilter_close.e878731a.png";